import { createStore, createLogger, Store } from "vuex";
import { InjectionKey } from "vue";
import { InfoResponse, Information, File } from "@/types";
import { useStore as baseUseStore } from "vuex";

const debug = process.env.NODE_ENV !== "production";
export const key: InjectionKey<Store<Information>> = Symbol();

export const store = createStore<Information>({
  state: {
    title: "WebEye Pro",
    timer: false,
    loading: false,
    connected: false,
    showIsOnline: true,
  },
  mutations: {
    setInfo(state, info: InfoResponse) {
      state.timer = info.enableCron;
      state.interval = info.sendTime;
      state.folderId = info.folderId;
      state.scriptId = info.scriptId;
      state.connected = true;
    },
    resetTitle(state) {
      state.title = "WebEye Pro";
      state.showIsOnline = true;
    },
    setTimer(state, timer: boolean) {
      state.timer = timer;
    },
    setInterval(state, interval: number) {
      state.interval = interval;
    },
    setFolder(state, folderId: string) {
      state.folderId = folderId;
    },
    setTitle(state, title: string) {
      state.title = title;
      state.showIsOnline = false;
    },
    setImageUrl(state, imageUrl: string) {
      state.imageUrl = imageUrl;
    },
    loading(state) {
      state.loading = true;
    },
    unloading(state) {
      state.loading = false;
    },
  },
  actions: {
    setFile(context, file: File) {
      context.commit(
        "setImageUrl",
        `https://drive.google.com/uc?export=view&id=${file.id}`
      );
      setTimeout(() => {
        context.commit("unloading");
        context.commit("setTitle", file.name);
      }, 2000);
    },
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});

export const useStore = (): Store<Information> => {
  return baseUseStore<Information>(key);
};
